import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, map } from 'rxjs';
import { ApiService } from './api.service';
import { Signature, StaffAPIResponse, StaffModel } from '../models/staff.model';
import { orderBy } from 'lodash';
import { AnswerModel } from '../models/answer.model';

@Injectable()
export class StaffService {
  private _staff$ = new BehaviorSubject<StaffModel[]>([]);

  constructor(private apiService: ApiService) {}

  get staff$(): Observable<StaffModel[]> {
    return this._staff$.pipe(map((staff) => staff.filter((person) => !person.attorneyFlag)));
  }

  get attorneys$(): Observable<StaffModel[]> {
    return this._staff$.pipe(map((staff) => staff.filter((person) => person.attorneyFlag)));
  }

  get staffWithSigImage$(): Observable<StaffModel[]> {
    return this.staff$.pipe(map((staff) => staff.filter((person) => person.hasSignatureImage)));
  }

  get attorneysWithSigImage$(): Observable<StaffModel[]> {
    return this.attorneys$.pipe(map((staff) => staff.filter((person) => person.hasSignatureImage)));
  }

  public fetchAll() {
    this.apiService.get<StaffAPIResponse>('staff/get', { showToast: false }).subscribe((response) => {
      const sortedResponse = orderBy(response.staff, [(user) => user.name.toLowerCase()]);
      if (response?.staff) this._staff$.next(sortedResponse);
    });
  }

  public getSignature(id: string, praSysId: number, templateId: number, answers: AnswerModel[]): Observable<Signature> {
    return this.apiService.post(
      `staff/GetSignature`,
      {
        TargetStaffID: id,
        praSysId: praSysId,
        templateId: templateId,
        answers: answers,
      },
      { showToast: true }
    );
  }
}
